/*
 * pageview 日活上报
 * @author: chenzhou
 * @update: 2021.9.1
 * @desc
 */


import axios from 'axios'


function getUUID() {
  let _uuid = null
  if(window.localStorage) {
    _uuid = window.localStorage.getItem('_uuid')
  }

  if(!_uuid) {
    _uuid = 'xxxxxyxxxxxyxx4xxxyxxxxxyxxxxxyxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });

    try {
      window.localStorage.setItem('_uuid', _uuid)
    } catch(error) {
    }
  }

  return _uuid;
}


let dailyReport = {
  options: {
    // 上报数据结构
    log: {
      // 平台 1：学堂 2：雨课堂 3：学堂云 ...
      platform: 2,
      terminal_type: 'h5',
      time: (new Date()).getTime(),
      language: 'zh_CN',
      // 原始ID 默认UUID
      original_id: getUUID(),
      // 用户ID
      distinct_id: '',
      event: 'page_view',
      properties: {
        channel: ''
      }
    }
  },

  /**
   * @method 用户ID读取
   * @params
   */
  getUserId(data) {
    try {
      const key = 'Report.Daily.User';
      let user = null;
      let uid = data && data.userId || window.user_id;

      try {
        // 本地缓存查找用户信息
        if(window.localStorage && window.localStorage[key]) {
          user = JSON.parse(window.localStorage.getItem(key));
        }

        // 用户ID缓存到本地
        if(!user && uid) {
          window.localStorage.setItem(key, JSON.stringify({ id: uid }));
        }
      } catch(error) {
        console.error(error);
      }

      if(!uid) {
        // 查找本地缓存 还是 请求接口读取
        if(user && user.id) {
          uid = user.id;
        }
      }

      return uid;
    } catch(error) {
      return null;
    }
  },

  /**
   * @method 更新日志数据
   * @params
   */
  updateLog(data, updateProperties) {
    let log = this.options.log;

    if(updateProperties && typeof data === 'object') {
      log.properties = Object.assign(log.properties, data)
      return
    }

    if(log && typeof data === 'object') {
      Object.assign(log, data);
    }
  },

  /**
   * @method 更新用户Id
   * @params
   */
  updateUserId(data) {
    let log = this.options.log;
    let uid = this.getUserId(data);

    // 大数据要求未登录时distinct_id 传空
    // if(!uid) {
    //   // 上报的用户Id不存在 使用设备ID保底
    //   if(!log.distinct_id) {
    //     uid = log.original_id;
    //   }
    // }

    uid && this.updateLog({ distinct_id: uid });
  },

  /**
   * @method 打点
   * @params
   */
  initLog(data = {}) {
    let log = this.options.log;

    try {
      // 各项目需要根据项目store取
      // let uid = data && data.userId || window.user_id || log.original_id;
      
      // 检测矫正UserId
      this.updateUserId(data);

      let properties = Object.assign(log.properties, data.properties, {
        channel: '',
        user_agent: navigator.userAgent,
        page_name: document.title,
        host: location.host,
        url: location.href,
        referer: document.referrer,
        original_referrer: document.referrer
      })
      
      this.options.log = Object.assign({}, log, {
        time: (new Date()).getTime(),
        // distinct_id: uid,
        properties
      });

      return this.options.log;
    } catch(error) {
      console.error('[initLog] exception:%s', error);

      return log;
    }
  },

  /**
   * @method 上报
   * @params
   */
  reportLog(data) {
    let URL = '/video-log/log/track/';

    let log = this.initLog(data);
    if(!log) {
      log = this.options.log;
    }

    const params = {
      'uip': '',
      'data': log,
      'ts_ms': (new Date()).getTime()
    };

    axios.post(URL, params);
  },

  /**
   * @method 自定义事件上报
   * @params
   */
  reportLogEvent(data) {
    let URL = '/video-log/log/track/';

    let log = this.initLog(data);
    if(!log) {
      log = this.options.log;
    }
    if (data.event) {
      log.event = data.event;
      log.terminal_type = (function() {
        var sUserAgent = navigator.userAgent.toLowerCase();
        if(sUserAgent && /flutterapp/i.test(sUserAgent)){
          return 'app-h5'
        }else if(window.__wxjs_environment && window.__wxjs_environment === 'miniprogram'){
          return 'minimp-h5'
        }else if(sUserAgent && /MicroMessenger/i.test(sUserAgent)){
          return 'gzh-h5'
        }else if(sUserAgent && /(ipad|iphone os|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|webview)/i.test(sUserAgent)){
          return 'h5'
        }
        return "web"
      })();
    }

    const params = {
      'uip': '',
      'data': log,
      'ts_ms': (new Date()).getTime()
    };

    axios.post(URL, params);
  },

}


export default dailyReport;



// WEBPACK FOOTER //
// ./src/util/daily-report.js